// Module
var code = "<stuff-form :item=\"view\" type=\"edit\" v-loading=\"loading\" element-loading-spinner=\"fas fa-spinner fa-pulse fa-3x\"></stuff-form>";
// Exports
module.exports = code;